import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import api, { formatApiErrorDetail } from "../lib/api";

export default function LeadForm({ source = "home", compact = false, dark = false }) {
  const [form, setForm] = useState({ name: "", phone: "", city: "Akola", electricity_bill: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please enter your name and phone");
      return;
    }
    if (!/^[6-9]\d{9}$/.test(form.phone.trim())) {
      toast.error("Please enter a valid 10-digit Indian mobile number");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", { ...form, source });
      setDone(true);
      toast.success("Thanks! Our solar expert will call you within 30 minutes.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className={`text-center p-8 rounded-2xl ${dark ? "bg-white/10 text-white" : "bg-[#F0EFEB]"}`} data-testid="lead-form-success">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#135934] text-white mb-4">
          <CheckCircle weight="fill" size={32} />
        </div>
        <h3 className="h3 mb-2">Quote Request Received!</h3>
        <p className={dark ? "text-white/80" : "text-[#5C7368]"}>
          Our solar expert will call <strong>{form.phone}</strong> within 30 minutes.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className={`space-y-3 ${compact ? "" : ""}`} data-testid={`lead-form-${source}`}>
      <div className="grid grid-cols-1 gap-3">
        <input
          type="text"
          name="name"
          placeholder="Your Name *"
          value={form.name}
          onChange={onChange}
          className="input-solar w-full px-4 py-3 rounded-xl border border-[#E5E3DB] bg-white text-[#0A1F15] placeholder:text-[#5C7368]"
          data-testid="lead-name-input"
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="10-digit Mobile Number *"
          value={form.phone}
          onChange={onChange}
          maxLength={10}
          className="input-solar w-full px-4 py-3 rounded-xl border border-[#E5E3DB] bg-white text-[#0A1F15] placeholder:text-[#5C7368]"
          data-testid="lead-phone-input"
          required
        />
        <div className="grid grid-cols-2 gap-3">
          <input
            type="text"
            name="city"
            placeholder="City"
            value={form.city}
            onChange={onChange}
            className="input-solar w-full px-4 py-3 rounded-xl border border-[#E5E3DB] bg-white text-[#0A1F15] placeholder:text-[#5C7368]"
            data-testid="lead-city-input"
          />
          <input
            type="text"
            name="electricity_bill"
            placeholder="Monthly Bill (₹)"
            value={form.electricity_bill}
            onChange={onChange}
            className="input-solar w-full px-4 py-3 rounded-xl border border-[#E5E3DB] bg-white text-[#0A1F15] placeholder:text-[#5C7368]"
            data-testid="lead-bill-input"
          />
        </div>
      </div>
      <button
        type="submit"
        disabled={loading}
        className="btn-primary w-full text-base disabled:opacity-60"
        data-testid="lead-submit-button"
      >
        {loading ? "Sending..." : "Get Free Solar Quote"}
        {!loading && <ArrowRight weight="bold" size={18} />}
      </button>
      <p className={`text-xs text-center ${dark ? "text-white/60" : "text-[#5C7368]"}`}>
        ✓ Free site visit  ✓ No obligation  ✓ Expert consultation
      </p>
    </form>
  );
}
